import React from "react";
import { ROLE_TEMPLATES, RoleTemplate } from "../../utils/roleTemplates";
import "./TemplateChips.css";

export type TemplateChipsProps = {
  onPickTemplate: (template: RoleTemplate) => void;
};

export const TemplateChips: React.FC<TemplateChipsProps> = ({ onPickTemplate }) => (
  <div className="templateChips">
    <span className="templateChipsLabel">Começar de um template:</span>
    {ROLE_TEMPLATES.map((t) => {
      const Icon = t.icon;
      return (
        <button
          key={t.key}
          className="templateChip"
          onClick={() => onPickTemplate(t)}
          type="button"
        >
          <Icon fontSize="small" />
          <span>{t.label}</span>
        </button>
      );
    })}
  </div>
);
